import React, { Component, useEffect, useState } from 'react';
import ServiceRequestsView from './ServiceRequestsView';
import { getCurrency, initOptionHeader, sortServiceRequestByStatus } from '../../utils/common';
import NewServiceRequestController from './NewServiceRequestController';
import crmservices from '../../wsclient/crmservices';

function ServiceRequestsController(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [showNewServiceRequest, onShowNewServiceRequest] = useState(false);

    const [service_requests, setServiceRequests] = useState([]);

    const [requestDetail, setRequestDetail] = useState(null);
    const [showDetail, onShowDetail] = useState(false);
    const [statusSeleted, setStatusSeleted] = useState(1);

    useEffect(()=>{
        getListServiceRequests();
    },[])
    const getListServiceRequests = async() =>{
       onShowLoading(true);
       let result = await crmservices.config.getListServiceRequests();
       if (result.code === 'OK' && result.data && result.data.content){
           setServiceRequests(result.data.content);
       }
       console.log('getListServiceRequests ====',result);     
       onShowLoading(false);
    }
    const onClickDetail = (item) =>{
        if (requestDetail&&requestDetail.id&&item.id===requestDetail.id){
            onShowDetail(!showDetail);
        }
        else{
            onShowDetail(true);
            setRequestDetail(item)
        }
    }
    const onCloseAndRefresh = async() =>{
        onShowNewServiceRequest(false);
        getListServiceRequests();
    }
    const setFilter = (value) => {
        setStatusSeleted(value)
    }
    const onFilterState = (data) => {
        let dataFilter = [];
        if(data && data.length > 0){
            dataFilter = data.filter(sr => sr.status.priority === statusSeleted);
        }
        return dataFilter;
    }
    return (
        <div>
            <ServiceRequestsView 
                open={props.open} 
                onClose= {props.onClose}
                service_request = {onFilterState(service_requests)}
                showLoading = {showLoading}
                showDetail={showDetail}
                transactionDetail={requestDetail}
                statusSeleted={statusSeleted}
                setFilter={setFilter}
                onClickDetail={onClickDetail}
                onFilterState={onFilterState}
                onShowNewServiceRequest={()=>onShowNewServiceRequest(true)}/>
            {showNewServiceRequest && <NewServiceRequestController
                open={showNewServiceRequest}
                onClose={()=>onShowNewServiceRequest(false)}
                onCloseAndRefresh={onCloseAndRefresh}/>
                }
        </div>
    );
}

export default ServiceRequestsController;